import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-283" data-mp="t41p8w0fjjzv">
      <div className="mx-auto max-w-5xl px-4" data-id="element-284" data-mp="o71lirr1ytbx">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-285" data-mp="j76u8n3d81qc">Resumen final</h2>
        <p className="mt-3 text-center text-muted" data-id="element-286" data-mp="1gvgx14az6tii">Las dos opciones, lado a lado</p>

        <div className="mt-10 overflow-x-auto pb-3" data-id="element-287" data-mp="1bvugolzuox5h">
          <table className="min-w-[700px] w-full border-separate border-spacing-y-2 text-sm" data-id="element-288" data-mp="1bwdoh9vse55s">
            <caption className="sr-only" data-id="element-289" data-mp="16v6hve5drc0p">Comparación entre el Megapack base y el Megapack con Upsell Premium</caption>
            <thead data-id="element-290" data-mp="12uw9juu489io">
              <tr className="text-left" data-id="element-291" data-mp="3rn096xi1t55a">
                <th scope="col" className="px-4 pb-2 text-xs font-extrabold uppercase tracking-wider text-muted" data-id="element-292" data-mp="3ro1jv0v5jpmh">Incluye</th>
                <th scope="col" className="px-4 pb-2 text-xs font-extrabold uppercase tracking-wider text-teal" data-id="element-293" data-mp="3nk3lisdniiuh">
                  Megapack · $19.990 ARS
                </th>
                <th scope="col" className="px-4 pb-2 text-xs font-extrabold uppercase tracking-wider text-petrol" data-id="element-294" data-mp="3naxzzkgj89zb">
                  Megapack + Premium · $27.990 ARS
                </th>
              </tr>
            </thead>
            <tbody data-id="element-295" data-mp="3dc023qx7v43n">
              {summaryRows.map(([feature, inBase, baseLabel, premiumLabel]) => <tr key={feature} className="bg-white" data-id="element-296" data-mp="2zl3ob67y8rgn">
                  <th scope="row" className="rounded-l-xl border-y border-l border-line px-4 py-4 text-left font-bold text-ink" data-id="element-297" data-mp="34deli1bb1z5i">
                    {feature}
                  </th>
                  <td className="border-y border-line px-4 py-4 text-muted" data-id="element-298" data-mp="2un23afqyqi2j">
                    <span className="inline-flex items-start gap-2" data-id="element-299" data-mp="2ukz2r1s6p6jk">
                      {inBase ? <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" data-id="element-300" data-mp="2lmngtd29iwxg" /> : <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert" data-id="element-301" data-mp="r65agjvvxslb" />}
                      {baseLabel}
                    </span>
                  </td>
                  <td className="rounded-r-xl border-y border-r border-line px-4 py-4 font-semibold text-teal" data-id="element-302" data-mp="hgloh5cvlim8">
                    <span className="inline-flex items-start gap-2" data-id="element-303" data-mp="dfa9dtrmofsa">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-aqua" data-id="element-304" data-mp="dcxius7t0x3m" />
                      {premiumLabel}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <p className="mt-1 text-center text-xs text-muted md:hidden" data-id="element-305" data-mp="113tddx3na6ek">Deslizá para ver la tabla completa</p>
      </div>
    </section>;
}